import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';
import { ColorToken } from '@elementary/common-ui/style/types';
import {
  getColor,
  radius,
  shadow,
  space,
} from '@elementary/common-ui/style/utils';

const Wrapper = styled(Flex)`
  align-items: center;
  height: 16px;
  width: 100%;
  padding: ${space('xxsPlus')};
  gap: ${space('xs')};
  border: ${({ theme }) => `1px solid ${theme.palette.border.selected}`};
  position: relative;
`;

const Segment = styled.div<{ $color: ColorToken; width: number }>`
  height: 8px;
  width: ${({ width }) => width}%;
  background-color: ${({ theme, $color }) => getColor(theme, $color)};
`;

const Marker = styled(Flex)<{ $value: number }>`
  position: absolute;
  left: ${({ $value }) => $value}%;
  width: 4px;
  height: 27px;
  background: ${({ theme }) => theme.palette.chart.inactive};
  border: 1px solid white;
  border-radius: ${radius('xs')};
  box-shadow: ${shadow('glow')};
`;

type Props = {
  segmentsColors: ColorToken[];
  segmentsValues?: number[];
  markerValue?: number;
};

const SegmentedLineChart = ({
  segmentsColors,
  segmentsValues,
  markerValue,
}: Props) => (
  <Wrapper>
    {segmentsColors.map((color, index) => (
      <Segment
        key={color}
        $color={color}
        width={
          segmentsValues ? segmentsValues[index] : 100 / segmentsColors.length
        }
      />
    ))}
    {markerValue !== undefined && <Marker $value={markerValue} />}
  </Wrapper>
);

export default SegmentedLineChart;
